const themeLightNotificationWarningSoft = '#FFF4D2';

export { themeLightNotificationWarningSoft };
